import { useSelectedFamilyMemberState } from '@/core/composables/useSelectedFamilyMemberState'
import { useSessionData } from '@/core/composables/useSessionData'

export function useSelectedCustomer() {
  const { currentCustomerId } = useSessionData()
  const selectedFamilyMember = useSelectedFamilyMemberState()

  return computed(() => selectedFamilyMember.value || currentCustomerId)
}
